import axios from './config/config'
const defaultRoute = 'produto/'
export default{
    list:(type)=>{
        return axios.get(`${defaultRoute}`)
    },
    create:(produto)=>{
        return axios.post(defaultRoute,produto)
    },
    uploadImage:(image)=>{
        return axios.post(defaultRoute+'upload',image)
    },
    update:(id, produto)=>{
        return axios.put(defaultRoute+id, produto)
    }, 
    addEstoque:(estoque)=>{
        return axios.patch(defaultRoute+'estoque', estoque)
    },
    remove:(id)=>{
        return axios.delete(defaultRoute+id)
    },
    
} 